import { render, staticRenderFns } from "./colorButton.vue?vue&type=template&id=d1df869c&scoped=true&"
import script from "./colorButton.vue?vue&type=script&lang=js&"
export * from "./colorButton.vue?vue&type=script&lang=js&"
import style0 from "./colorButton.vue?vue&type=style&index=0&id=d1df869c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1df869c",
  null
  
)

export default component.exports